import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { Button } from '@/components/ui/button';
import { ArrowRightIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { columnsServerlessProject } from './type';
import { Badge } from '@/components/ui/badge';
import BadgeProjectStatus from '../../components/BadgeProjectStatus';

export const columns: ColumnDef<columnsServerlessProject>[] = [
  // {
  //   accessorKey: 'projectId',
  //   id: 'projectId',
  // },
  {
    accessorKey: 'projectName',
    header: 'Project Name',
    cell: ({ row }) => {
      const projectName = row.getValue('projectName') as string;
      return <span>{projectName || row.original.projectId}</span>;
    },
  },
  {
    accessorKey: 'instanceType',
    header: 'Instance Type',
  },
  {
    accessorKey: 'createdAt',
    header: 'Created Date',
    cell: ({ row }) => {
      return (
        <span>{dayjs(row.getValue('createdAt')).format('DD MMM, HH:mm')}</span>
      );
    },
    size: 110,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      return <BadgeProjectStatus status={row.getValue('status')} />;
    },
    size: 100,
  },
  {
    accessorKey: 'action',
    header: '',
    cell: () => {
      return (
        <Button variant="ghost" size="icon">
          <ArrowRightIcon />
        </Button>
      );
    },
    size: 40,
  },
];
